module.exports = __webpack_public_path__ + "img/17.4a8e848f.jpg";